import { createSlice } from '@reduxjs/toolkit'
import { GlobalModalVariant } from '../../types/commonTypes'

type GlobalModalState = {
	isModalOpen: boolean
	id?: string | number
	variant: GlobalModalVariant,
	canEditLinkFees: boolean
}

const initialState: GlobalModalState = {
	isModalOpen: false,
	variant: '',
	canEditLinkFees: false
}

export const globalModalSlice = createSlice({
	name: 'globalModal',
	initialState,
	reducers: {
		openGlobalModal: (state, action) => {
			state.isModalOpen = true
			state.variant = action.payload.variant
			state.id = action.payload.id
			state.canEditLinkFees = action.payload.canEditLinkFees ?? false
		},
		closeGlobalModal: state => {
			state.isModalOpen = false
			state.variant = ''
			state.id = ''
			state.canEditLinkFees = false
		},
	},
})

export const { openGlobalModal, closeGlobalModal } = globalModalSlice.actions

export default globalModalSlice.reducer
